import React, { useMemo } from 'react';
import _ from 'underscore';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { StringUtils } from '@bingads-webui-clientcenter/common-utils';
import { TaxTypeFormPropTypes } from '../shapes';
import { GlobalTaxForm } from './global-taxform';
import { CustomValidateItems } from '../validator';
import { EmptyTaxForm } from './empty-taxform';
import { registerTaxform } from '../taxform-store';
import { TWTaxViewTaxForm } from './viewtaxforms/taiwan-viewtaxform';
import { EmptyViewTaxForm } from './viewtaxforms/empty-viewtaxform';
import { withViewTaxFormWithFilledEmptyTaxValue, withTaxFormByPilot, getTaxTypeLabel } from '../utils';
import { GlobalTaxIdHelpPopUpId, GlobalTaxIdCountryCodeToPilots } from '../constants';

const {
  TaxTWVatNumberRegExp, TaxType, TaxLabelFormat, CountryCode,
} = Constants;
const { regexTest } = StringUtils;

const taxIdValidator = _.partial(regexTest, TaxTWVatNumberRegExp);
const taxSchemaGetter = () => ({
  name: 'Taiwan Taxation Validation Schema',
  type: 'object',
  properties: {
    [TaxType.VatNumber]: {
      type: 'string',
      required: true,
      helpPopupTopic: GlobalTaxIdHelpPopUpId,
    },
  },
});

export const TWTaxForm = ({
  i18n,
  onValidate,
  showLineByLineFormGroup,
  alwaysShowError,
  data,
  mtData,
  taxCertification,
  mtTaxCertification,
  disabled,
}) => {
  const vatValidatorErrorMessage = useMemo(() => i18n.getString(CustomValidateItems.TaiwanVATFormatValidation), [i18n]);
  const vatLabel = useMemo(() => getTaxTypeLabel(TaxType.VatNumber, i18n, { labelFormat: TaxLabelFormat.RequiredForBusiness, countryCode: CountryCode.TW }), [i18n]);

  return (
    <GlobalTaxForm
      i18n={i18n}
      onValidate={onValidate}
      taxSchemaGetter={taxSchemaGetter}
      vatLabel={vatLabel}
      showLineByLineFormGroup={showLineByLineFormGroup}
      vatValidatorErrorMessage={vatValidatorErrorMessage}
      alwaysShowError={alwaysShowError}
      data={data}
      mtData={mtData}
      taxCertification={taxCertification}
      mtTaxCertification={mtTaxCertification}
      disabled={disabled}
      taxIdValidator={taxIdValidator}
      showTaxCert={false}
    />
  );
};

TWTaxForm.propTypes = TaxTypeFormPropTypes;

const globalPilotFlag = GlobalTaxIdCountryCodeToPilots.TW;

const TaxForm = withTaxFormByPilot({
  pilotFlag: globalPilotFlag,
  PilotForm: TWTaxForm,
  DefaultForm: EmptyTaxForm,
});

const ViewTaxForm = withTaxFormByPilot({
  pilotFlag: globalPilotFlag,
  PilotForm: TWTaxViewTaxForm,
  DefaultForm: EmptyViewTaxForm,
});

registerTaxform('/TW/', TaxForm, withViewTaxFormWithFilledEmptyTaxValue({ ViewTaxForm, getTaxSchema: taxSchemaGetter }));
